"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const MarketsController_1 = require("@bitcoin-portal/neko-web-sdk/lib/controllers/MarketsController");
const react_1 = require("react");
const useRate = (fiat, crypto) => {
    const [rate, setRate] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const getRates = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                if (!fiat || !crypto)
                    return;
                const res = yield MarketsController_1.MarketsController.convertRates(crypto, fiat);
                if (!res.getValue())
                    return;
                const val = res.getValue();
                setRate(val[fiat].rate);
            }
            catch (error) {
                console.log("error fetching rates", error);
            }
        });
        getRates();
    }, [crypto, fiat]);
    return rate;
};
exports.default = useRate;
//# sourceMappingURL=useRate.js.map